import JassEnum from './enum';

/**
 * type alliancetype
 */
export default class JassAllianceType extends JassEnum {}
